<template>
    <div>
    </div>
</template>

<script>
export default {
  name: 'notFound',
  data() {
    return {};
  },
};
</script>


// WEBPACK FOOTER //
// src/components/views/NotFound.vue